module.exports = __webpack_public_path__ + "static/media/VorbereitungBH01.b19daadd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/VorbereitungBH01.jpg
// module id = 342
// module chunks = 0